export const themeLight = {
  backgroundSecondary: '#faf9f8',
  backgroundSecondaryFocused: '#bfbfb8',
  secondaryText: '#605e5c',
  warning: '#f2be11',
  success: '#28cc25',
  error: '#e31c19',
  backgroundBody: '#f9f9f9',
};
